export default "__VITE_ASSET__Clx08fP3__"